import React from "react"
import type { PageProps } from "gatsby"

import SEO from "~components/shared/seo"
import { OutfitterContent } from "~components/pages/outfitter/outfitter-content"
import type { PublicOutfitterFieldsFragment } from "~graphql/generated/graphql"
import { EntityType } from "~utils/event-tracking/event-tracking-constants"
import { useTrackSelectContent } from "~utils/use-track-select-content"

interface Props {
    readonly outfitter: PublicOutfitterFieldsFragment
}

export default function Outfitter({
    pageContext: { outfitter },
}: PageProps<object, Props>) {
    useTrackSelectContent({
        entityId: outfitter.id,
        entityType: EntityType.OUTFITTERS,
    })

    return (
        <>
            <SEO
                title={`${outfitter.name} - Book Your Trip`}
                image={outfitter.photos[0]?.url}
                description={`Plan your next outdoor adventure with ${outfitter.name} in ${outfitter.location?.state}. ${outfitter.listings_count} trips listed.`}
            />
            <OutfitterContent outfitter={outfitter} />
        </>
    )
}
